import { observable, selector } from '@poa/state';
import { ACCESS_LEVEL } from '../auth/auth.constants';
import { filteredData, isAllColumnsSelected } from './accounts.selectors';

const columns = [
  {
    name: 'panel',
    label: 'Пан',
    width: 55,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'status',
    label: 'С',
    width: 25,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'photo',
    label: 'Фото',
    width: 60,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'full_name',
    label: 'ФИО',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'manager',
    label: 'Менеджер',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'team_lead',
    label: 'Тимлид',
    width: 120,
    sectionId: 'section_1',
    isSelected: true,
    editable: false
  },
  {
    name: 'operator',
    label: 'Оператор',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'scout',
    label: 'Скаут',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'account_manager',
    label: 'ММ',
    width: 140,
    sectionId: 'section_1',
    isSelected: true,
    editable: false
  },
  {
    name: 'shifts',
    label: 'Cмены',
    width: 80,
    sectionId: 'section_1',
    isSelected: true,
    editable: false
  },
  {
    name: '@@separator1',
    label: '—',
    isSelected: true
  },
  {
    name: 'form_level',
    label: 'Уровень',
    width: 80,
    sectionId: 'section_1',
    isSelected: true,
    editable: false
  },
  {
    name: 'nick',
    label: 'Ник',
    width: 130,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: 'id',
    label: 'ID',
    width: 100,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: 'number',
    label: '№',
    width: 100,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: '@@separator2',
    label: '—',
    isSelected: true
  },
  {
    name: 'register_date',
    label: 'Регистр.',
    width: 80,
    sectionId: 'section_3',
    isSelected: true
  },
  {
    name: 'transfer_date',
    label: 'Трансфер',
    width: 85,
    sectionId: 'section_3',
    isSelected: true
  },
  {
    name: '@@separator5',
    label: '—',
    isSelected: true
  }
];

export const accountsInitialState = {
  accounts: {
    data: [],
    reports: [],
    activeReport: {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    },
    activeReportId: null,
    model: null,
    originalModel: null,
    map_data: [],
    isEdit: false,
    ui: {
      favorites: []
    },
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      currentPage: 1,
      accountsCount: 0,
      pages: 1,
      pageSize: 25
    },
    filters: {
      startDate: null,
      endDate: null,
      grouping: {
        selected: null,
        options: []
      },
      status: {
        selected: null,
        options: []
      },

      columnSettings: {
        // default preset
        currentPresetId: 0,
        // presets from server
        availablePresets: [
          // preset model
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      isDecimal: false,
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset: selector(store => {
        const selectedPreset = store.accounts.filters.columnSettings.availablePresets.find(
          preset => preset.id === store.accounts.filters.columnSettings.currentPresetId
        );
        const { columnsConfiguration } = selectedPreset;
        let availableColumns = columns.map(col => col.name);
        let filteredColumns = columnsConfiguration.slice();

        switch (store.auth.accessLevel) {
          case ACCESS_LEVEL.operator: {
            availableColumns = [
              'status',
              'photo',
              'full_name',
              'team_lead',
              'operator',
              'form_level',
              'nick',
              'id',
              'register_date',
              'transfer_date',
              'social'
            ];

            break;
          }
          case ACCESS_LEVEL.teamlead: {
            availableColumns = [
              'panel',
              'status',
              'photo',
              'full_name',
              'manager',
              'form_level',
              'team_lead',
              'operator',
              'nick',
              'id',
              'number',
              'register_date',
              'transfer_date',
              'social',
              'income'
            ];

            break;
          }

          default:
            break;
        }

        filteredColumns = columnsConfiguration.filter(
          column => availableColumns.includes(column.name) || column.name.includes('@@')
        );

        return observable({ ...selectedPreset, columnsConfiguration: filteredColumns });
      }),
      currentPresetColumnsList: selector(store =>
        store.accounts.selectors.selectedPreset.columnsConfiguration.map(column => column.name)
      )
    }
  }
};
